import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { OnboardingStepperComponent } from '@ki/onboarding/components/onboarding-stepper/onboarding-stepper.component';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'ki-onboarding-header',
  standalone: true,
  imports: [OnboardingStepperComponent, RouterLink, SvgIconComponent],
  templateUrl: './onboarding-header.component.html',
  styleUrl: './onboarding-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingHeaderComponent {}
